import { render, staticRenderFns } from "./WorkPackViewsContainer.vue?vue&type=template&id=7f61b2d0&"
import script from "./WorkPackViewsContainer.vue?vue&type=script&lang=js&"
export * from "./WorkPackViewsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f61b2d0')) {
      api.createRecord('7f61b2d0', component.options)
    } else {
      api.reload('7f61b2d0', component.options)
    }
    module.hot.accept("./WorkPackViewsContainer.vue?vue&type=template&id=7f61b2d0&", function () {
      api.rerender('7f61b2d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workPacks/components/WorkPackViewsContainer.vue"
export default component.exports